import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const SonicBoomAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  ctx.lineWidth = 30 * (1 - progress);
  drawBlastShape(ctx, e, e.maxRadius + progress * 200);
  ctx.stroke();
};

registerBlastAnimation('SONIC_BOOM', SonicBoomAnimation);
